"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1391],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(58510);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1977);
// EXTERNAL MODULE: ./node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(8027);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js
'use client';



const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 61391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InsuranceList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/services/medicareInsuranceCard.tsx






function MedicareInsuranceCard(param) {
    var onSubmit = param.onSubmit, loading = param.loading;
    var handleMedicareOriginalSelection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isMedicareOriginal) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onSubmit(isMedicareOriginal);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMedicareOriginalSelection(isMedicareOriginal) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            my: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                align: "center",
                color: "primary",
                sx: {
                    fontFamily: "JazminAltLight",
                    fontSize: "26px",
                    lineHeight: "31.2px",
                    marginTop: 1,
                    mt: 1
                },
                children: "Do you have Original Medicare?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h3",
                color: "primary",
                align: "center",
                sx: {
                    my: 2,
                    fontSize: "16px",
                    fontFamily: "ABCDiaTypeRegular",
                    fontWeight: "400"
                },
                children: "Your insurance card will look like this."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/provider/medicare-original-card.png",
                layout: "intrinsic",
                alt: "Medicare Original Card",
                width: 377,
                height: 251
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                        disabled: loading,
                        loading: loading,
                        fullWidth: true,
                        size: "large",
                        variant: "contained",
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return handleMedicareOriginalSelection(true);
                                    case 2:
                                        return _ctx.abrupt("return", _ctx.sent);
                                    case 3:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: "Yes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                        disabled: loading,
                        loading: loading,
                        fullWidth: true,
                        variant: "contained",
                        size: "large",
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return handleMedicareOriginalSelection(false);
                                    case 2:
                                        return _ctx.abrupt("return", _ctx.sent);
                                    case 3:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: "No*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                sx: {
                    my: 2,
                    fontSize: "14px",
                    maxWidth: "350px"
                },
                children: "*If not, then please select NO. You likely have Medicare Advantage through another insurance provider."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/services/insurance-list.tsx








var MEDICARE_NAME = "MEDICARE";
function InsuranceList(param) {
    var onSubmit = param.onSubmit, onSelected = param.onSelected, loading = param.loading;
    var ref = (0,react.useState)(null), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), showMedicare = ref1[0], setShowMedicare = ref1[1];
    var handleSelect = function(payor) {
        setSelected(payor);
        onSelected(payor);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selected === MEDICARE_NAME) {
                            setShowMedicare(true);
                        } else if (selected) {
                            onSubmit(selected);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMedicareSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selected) onSubmit(selected);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMedicareSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    if (showMedicare) return /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicareInsuranceCard, {
        onSubmit: handleMedicareSubmit,
        loading: loading
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h1",
                align: "center",
                sx: {
                    fontFamily: "JazminAltLight",
                    fontSize: "26px",
                    lineHeight: "31.2px",
                    letterSpacing: "-2%",
                    marginTop: 1,
                    color: "inherit",
                    mt: 1,
                    mb: 3
                },
                children: "Select your insurance provider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: {
                        xs: "100%",
                        sm: "600px"
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "grid",
                            gap: 1,
                            alignItems: "center",
                            justifyContent: "center",
                            gridTemplateColumns: "repeat(2, 1fr)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("BCBS");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    height: 54,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8",
                                    background: selected !== "BCBS" ? "#fff" : "#D4DACF"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/bcbs.png",
                                    layout: "intrinsic",
                                    alt: "bcbs",
                                    width: 100,
                                    height: 45
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("AETNA");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8",
                                    background: selected !== "AETNA" ? "#fff" : "#D4DACF"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/aetna.png",
                                    layout: "intrinsic",
                                    alt: "aetna",
                                    width: 66,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("MEDICARE");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    background: selected !== "MEDICARE" ? "#fff" : "#D4DACF",
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/medicare.png",
                                    layout: "intrinsic",
                                    alt: "medicare",
                                    width: 131,
                                    height: 44
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("UHC");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8",
                                    background: selected !== "UHC" ? "#fff" : "#D4DACF"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/united.png",
                                    layout: "intrinsic",
                                    alt: "united",
                                    width: 86,
                                    height: 46
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("CIGNA");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8",
                                    background: selected !== "CIGNA" ? "#fff" : "#D4DACF"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/cigna.png",
                                    layout: "intrinsic",
                                    alt: "cigna",
                                    width: 61,
                                    height: 45
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("HUMANA");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    background: selected !== "HUMANA" ? "#fff" : "#D4DACF",
                                    justifyContent: "center",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/humana.png",
                                    layout: "intrinsic",
                                    alt: "humana",
                                    width: 81,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("KAISER");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: selected !== "KAISER" ? "#fff" : "#D4DACF",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/kaiser.png",
                                    layout: "intrinsic",
                                    alt: "kaiser",
                                    width: 102,
                                    height: 31
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("AARP");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: selected !== "AARP" ? "#fff" : "#D4DACF",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/aarp.png",
                                    layout: "intrinsic",
                                    alt: "aarp",
                                    width: 75,
                                    height: 43
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("EMBLEM");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: selected !== "EMBLEM" ? "#fff" : "#D4DACF",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/provider/emblem.png",
                                    layout: "intrinsic",
                                    alt: "united",
                                    width: 121,
                                    height: 35
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                elevation: 0,
                                onClick: function() {
                                    return handleSelect("OTHER");
                                },
                                sx: {
                                    padding: 0.5,
                                    border: 1,
                                    borderRadius: 1,
                                    width: 173,
                                    display: "flex",
                                    height: 54,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: selected !== "OTHER" ? "#fff" : "#D4DACF",
                                    borderColor: "#ADB8B8"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    align: "center",
                                    children: "Other*"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        align: "center",
                        sx: {
                            my: 2,
                            fontSize: "14px"
                        },
                        children: "* Your insurance information will be collected during intake. Please note, at this time we are only able to bill Medicaid in TN and CO. Those with Medicaid outside of these states would need to enroll in our cash pay option."
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    my: 1,
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        component: "p",
                        color: "primary",
                        children: "Please wait..."
                    })
                ]
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                disabled: selected === null,
                variant: "contained",
                onClick: handleSubmit,
                fullWidth: true,
                children: "Confirm"
            })
        ]
    });
};


/***/ })

}]);